import { Box, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Logo } from '~/src/components/atoms'
import { LoginFormFeature, OnSubmitHandler } from '~/src/components/molecules/Form/LoginFormFeature'
import { AuthPage } from '~/src/components/templates'
import { useAuth, useMessage } from '~/src/hooks'
import { useState } from 'react'

export const Login = () => {
  const { login, isAuthenticatedError } = useAuth()
  const navigate = useNavigate()
  const { handleOpenWithSuccessMessage, handleOpenWithErrorMessage } = useMessage()
  const [loading, setLoading] = useState<boolean>(false)

  const loginHandler: OnSubmitHandler = async (v) => {
    setLoading(true)
    try {
      await login(v)
      handleOpenWithSuccessMessage('Login Success!!')
      setLoading(false)
      navigate('/admin')
    } catch (e) {
      console.log(e)
      setLoading(false)
      handleOpenWithErrorMessage('Error')
    }
  }

  return (
    <AuthPage>
      <Paper sx={{ width: '380px', padding: 5 }}>
        <Box mx={'auto'} width={'170px'} height={'60px'}>
          <Logo />
        </Box>
        <Box marginY={2}>
          <LoginFormFeature
            onSubmit={loginHandler}
            isAuthenticatedError={isAuthenticatedError}
            loading={loading}
          />
        </Box>
      </Paper>
    </AuthPage>
  )
}
